<template>
    <div class="row main-content mx-0">
        <div class="col-md-12">
            <div class="d-flex justify-content-between">
                <!-- SECTION TITLE/HEADER -->
                <h1 class="first-header heading-large">
                    <i class="fas mr-2" :class="selectedNav.top.icon"></i>{{ selectedNav.top.title }}
                </h1>

                <!-- CREATE NEW USER BUTTON -->
                <button v-if="selectedNav.top.id === 'TEAM_MANAGEMENT'"
                    class="btn btn-actionable" :class="[ $breakpoint.smAndDown ? 'btn-icon btn-new--mobile' : 'my-3']"
                    @click="openUserModal(true)">
                    <i v-if="$breakpoint.smAndDown" class="fas fa-plus" icon="plus" />
                    <span v-else>Create new user</span>
                </button>
            </div>

            <div class="panel-tabs">
                <!-- TOP NAVIGATION -->
                <div class="nav-tabs_parent">
                    <ul class="nav nav-tabs">
                        <li v-for="(tab, index) in tabs" :key="index" @click.prevent="selectNavItem('TOP', tab.id)"
                            class="nav-item" :class="{'active' : tab.id == selectedNav.top.id}">
                            <a class="nav-link" href="#">{{ tab.title }}</a>
                        </li>
                    </ul>
                </div>
                
                <div class="panel-tab-content card border-radius-top-left-0 px-4 pt-2 pb-4">
                    <div class="row">
                        <!-- SIDE NAVIGATION -->
                        <div class="col-xl-3 col-md-4 px-0"
                            :class="{'border-right' :!$breakpoint.smAndDown}">
                            <!-- ACCOUNT INFORMATION -->
                            <account-information 
                                :account="accountDetails"
                                :isModal="false" 
                                class="px-3 py-3" 
                            />

                            <!-- SIDENAV -->
                            <div v-if="selectedNav.top.id === 'MY_ACCOUNT'" class="nav flex-column nav-pills" role="tablist" aria-orientation="vertical">
                                <div v-for="(nav, idx) in sidenav" :key="idx">
                                    <a class="nav-link" :class="{'active': selectedNav.side.id === nav.id}" 
                                        data-toggle="pill" role="tab" href="#" @click="selectNavItem('SIDE', nav.id)">{{ nav.title }}</a>
                                </div>
                            </div>
                        </div>

                        <!-- TAB CONTENT -->
                        <div class="tab-content col-xl-9 col-md-8">

                            <!-- MY ACCOUNT -->
                            <div v-if="selectedNav.top.id === 'MY_ACCOUNT'">
                                <!-- USER DETAILS -->
                                <div class="tab-pane fade show" v-if="selectedNav.side.id === 'PERSONAL_INFORMATION'" role="tabpanel">
                                    <user-information :key="userDetails._id" :user="userDetails" :account="accountDetails"
                                        :class="[ !$breakpoint.mdAndDown ? 'py-4 pl-5 pr-4' : 'p-3']" :isModal="false"
                                        @updateUser="getUserDetails()" />
                                </div>

                                <!-- PASSWORD -->
                                <div class="tab-pane fade show" v-if="selectedNav.side.id === 'PASSWORD'" role="tabpanel">
                                    <password-form :isUserLoggedIn="true" :class="!$breakpoint.mdAndDown ? 'py-4 pl-5 pr-4' : 'p-3'" />
                                </div>
                            </div>

                            <!-- TEAM MANAGEMENT -->
                            <div v-else-if="selectedNav.top.id === 'TEAM_MANAGEMENT'" :style="$breakpoint.mdAndDown ? '' : 'min-height: calc(100vh - 250px)'">
                                <div class="table-container px-0">
                                    <table class="table responsive-table">
                                        <thead :class="teamMembers.length > 0 ? 'thead-light' : 'd-none'">
                                            <tr class="d-none d-lg-table-row">
                                                <th label="Name">Name</th>
                                                <th label="Email">Email</th>
                                                <th label="Phone">Phone number</th>
                                                <th label="Admin">Admin</th>
                                                <th label="Actions" colspan="3"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- If no team members is found -->
                                            <tr v-if="teamMembers.length < 1" class="bg-transparent border-0 shadow-none w-100">
                                                <td 
                                                    class="px-0"
                                                    :class="{'no-results d-flex' : $breakpoint.mdAndDown}"
                                                >
                                                    <div class="w-100 alert tables-alert-custom-message-notify mt-3 text-center">
                                                        <i class="fas fa-info-circle mr-2"></i>You haven't created any users on your account yet.
                                                    </div> 
                                                </td>
                                            </tr>
                                            <tr v-else v-for="(member, idx) in teamMembers" :key="idx" 
                                                :class="[{'pt-2 pb-4': $breakpoint.mdAndDown}]">
                                                <td label="Name" v-if="member.status_id !== eUserStatus.DeleteRequest">
                                                    <span class="text-left" :class="{ 'text-t_silver' : member.status_id === 200 }">{{ `${member.firstName} ${member.lastName}` }}</span>
                                                </td>
                                                <td label="Email" v-if="member.status_id !== eUserStatus.DeleteRequest">
                                                    <span class="text-left" :class="{ 'text-t_silver' : member.status_id === 200 }">{{ member.email }}</span>
                                                </td>
                                                <td label="Phone" v-if="member.status_id !== eUserStatus.DeleteRequest">
                                                    <span class="text-left" :class="{ 'text-t_silver' : member.status_id === 200 }">{{ member.phone }}</span>
                                                </td>
                                                <td label="Admin" v-if="member.status_id !== eUserStatus.DeleteRequest">
                                                    <input type="checkbox" v-model="member.isAdmin" @click.prevent="setAdminStatus(member)" />
                                                </td>
                                                <td class="td-actions text-center" v-if="member.status_id !== eUserStatus.DeleteRequest">
                                                    <button
                                                        class="btn btn-icon btn-icon-color td-sticky td-left-bottom"
                                                        :class="{'pt-4' : $breakpoint.mdAndDown}"
                                                        @click="openUserModal(true, member)"
                                                    >
                                                        <i class="fas fa-edit fa-lg"></i>
                                                    </button>
                                                </td>
                                                <td class="td-actions text-center pl-5" v-if="member.status_id !== eUserStatus.DeleteRequest">
                                                    <div class="d-flex justify-content-center td-sticky td-center-bottom">
                                                        <label class="switch">
                                                            <input type="checkbox" class="on-off-toggler" :checked="member.isActive" 
                                                                @click.prevent="changeUserStatus(member)">
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </div>
                                                </td>
                                                <td class="td-actions text-center" v-if="member.status_id !== eUserStatus.DeleteRequest">
                                                    <button 
                                                        class="btn btn-icon td-sticky td-right-bottom" 
                                                        :class="{'pt-4' : $breakpoint.mdAndDown}"
                                                        @click="confirmItemRemoval('USER', member)"
                                                    >
                                                        <i class="fas fa-trash-alt fa-lg" ></i>
                                                    </button>
                                                </td>
                                                <!-- USER WITH A DELETE REQUEST SUBMITTED -->
                                                <td v-else colspan="7" class="no-results">
                                                    <div class=" alert tables-alert-custom-message-notify my-1 text-center">
                                                        <i class="fas fa-info-circle mr-2"></i>
                                                        OnlineFuels has received your request to delete the user. The user {{ `${member.firstName} ${member.lastName}` }}  is already disabled and cannot access the platform.
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- CONFIRMATION MODAL TO REMOVE ADMIN ACCESS OR USER -->
            <confirmation-remove-item v-if="showItemRemovalConfirmation" ref="confirmationRemoveItem"
                :itemToRemove="itemToRemove" :itemType="itemToRemoveType" 
                @removalConfirmed="getRemovalFunction()" />

            <!-- EDIT TEAM MEMBER MODAL -->
            <user-modal v-if="isUserModalOpened" ref="userModal" :user="userEdited" :account="accountDetails" 
                @changesSaved="getTeamMembersList()" @closeUserModal="openUserModal(false)" />
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import breakpoint from '@/mixins/index';
import AccountInformation from "@/components/Account/AccountInformation.vue";
import UserInformation from "@/components/Account/UserInformation.vue";
import PasswordForm from "@/components/Login/PasswordForm.vue";
import ConfirmationRemoveItem from '@/modals/ConfirmationRemoveItem.vue';
import UserModal from "@/modals/UserModal.vue";

import { redactUser, updateUserDetails } from "@/api/users";
import { eUserStatus } from "@/util/enums/user.js";

export default {
    mixins: [breakpoint],
    components: {
        AccountInformation,
        UserInformation,
        PasswordForm,
        ConfirmationRemoveItem,
        UserModal
    },
    data() {
        return {
            sidenav: [
                { title: "Personal Information", id: "PERSONAL_INFORMATION" },
                { title: "Password", id: "PASSWORD" }
            ],
            selectedNav: {
                top: {},
                side: {}
            },
            userDetails: {},
            unchangedUserDetails: {},
            accountDetails: {},
            teamMembers: [],
            isUserModalOpened: false,
            userEdited: {},
            eUserStatus,
        }
    },
    created: async function() {
        await this.getUserDetails();
        this.getAccountDetails();
        this.selectNavItem("TOP", this.tabs[0].id);
        this.selectNavItem("SIDE", this.sidenav[0].id);
    },
    computed: {
        ...mapState('accounts', ['userRoles']),
        ...mapState('login', ['userLoggedIn']),
        ...mapState('itemRemoval', ['showItemRemovalConfirmation', 'itemToRemove', 'itemToRemoveType', 'eRemoveItemType']),
        tabs: {
            get: function(){
                let availableTabs = [{ title: 'My Account', id: "MY_ACCOUNT", icon: "fa-user-circle" }];

                // Show team management tab if this is an admin account
                if (this.userRoles && this.userRoles.type_id === "admin"){
                    availableTabs[1] = { title: 'Team Management', id: "TEAM_MANAGEMENT", icon: "fa-users" };
                    this.getTeamMembersList();
                }

                return availableTabs;
            }
        },
        switchTabIfNotAnAdmin: function(){ // If user's admin access is removed, let's bring them back to the "My Account" tab
            const defaultNavItemId = "MY_ACCOUNT";

            if (this.userRoles && this.userRoles.type_id === "user" && this.selectedNav.top.id !== defaultNavItemId) // Do nothing if user is already on the "My Account" tab
                this.selectNavItem("TOP", defaultNavItemId);
        }
    },
    watch: {
        switchTabIfNotAnAdmin(){}
    },
    methods: {
        ...mapActions('notifications', ['displayActionConfirmation', 'sendAdminAlert']),
        ...mapActions('itemRemoval', ['openConfirmationRemoval']),
        selectNavItem: function(nav, id){
            if (nav === "TOP")
                this.selectedNav.top = this.tabs.find(t => t.id === id);
            else
                this.selectedNav.side = this.sidenav.find(s => s.id === id);

            this.userDetails = Object.assign({}, this.unchangedUserDetails); // Reset user details to unchanged state
        },
        getUserDetails: async function(){
            const response = await this.axios.get('/api/getUserDetails', {params: {
                userId: this.userLoggedIn.userId
            }})

            if (response.data.success){
                this.unchangedUserDetails = response.data.user; // Make an unchanged copy of user details to prevent changed data being flushed on market refresh
            }
        },
        getAccountDetails: async function(){
            const response = await this.axios.get('/api/getAccountDetails', {params: {
                accountId: this.userLoggedIn.id
            }})

            if (response.data){
                this.accountDetails = response.data;
            }
        },
        getTeamMembersList: async function(){
            try {
                const res = await this.axios.get('/api/getUsersByAccount');
                this.teamMembers = res.data.users.filter(u => u._id !== this.userLoggedIn.userId) // Do not include the logged in user
                                                 .map(u => ({...u, isAdmin: u.type_id === "admin", isActive: u.status_id === 100})); // Assign Boolean values to indicate user's Admin and active statuses
            } catch (er) {
                console.dir(er);
            }
        },
        setAdminStatus: async function(member, isAdminRemovalConfirmed){
            // If removing admin access, make sure the user has to confirm their action first
            if (member.type_id === "admin" && !isAdminRemovalConfirmed)
                return this.confirmItemRemoval(this.eRemoveItemType.AdminAccess, member);
            
            const payload = {
                typeId: member.type_id === "admin" ? "user" : "admin"
            };

            try {
                await updateUserDetails(member._id, payload);
                this.getTeamMembersList();
            } catch(er) {
                if (er.response.status === 403) // User is not authorised to perform this action
                    this.confirmItemRemoval(this.eRemoveItemType.UnauthorisedAction);
                else 
                    return; // TO-DO: Decide how to handle other error types
            }
        },
        confirmItemRemoval: async function(itemType, itemToRemove){
            const payload = {
                item: itemToRemove,
                type: itemType,
                showWindow: true
            };
            this.openConfirmationRemoval(payload).then(() => {
                // Wait until data is ready then display modal
                setTimeout(() => {
                    let element = this.$refs.confirmationRemoveItem.$el;
                    $(element).modal({backdrop: 'static', keyboard: false});
                }, 500);
            })
        },
        openUserModal: function(isOpening, member){
            if (member) // Decide whether we are editing a team member or not
                this.userEdited = Object.assign({}, member); // Use deep copy to make sure that object reference is not kept
            else
                this.userEdited = {};
            
            this.isUserModalOpened = isOpening;

            if (isOpening){
                setTimeout(() => {
                    let element = this.$refs.userModal.$el;
                    $(element).modal({backdrop: 'static', keyboard: false});
                }, 500);
            } else {
                this.getTeamMembersList();
            }
        },
        changeUserStatus: async function(member, isActionConfirmed){
            let statusId;

            if (member.status_id === eUserStatus.Active) { // Disabling a team member
                if (!isActionConfirmed) // If disabling a team member, make sure the user has to confirm their action first
                    return this.confirmItemRemoval(this.eRemoveItemType.ActiveUser, member);
                else
                    statusId = eUserStatus.Inactive;
            } else {
                statusId = eUserStatus.Active;
            }
            
            try {
                await updateUserDetails(member._id, { statusId });
                this.getTeamMembersList();
            } catch(er) {
                if (er.response.status === 403) // User is not authorised to perform this action
                    this.confirmItemRemoval(this.eRemoveItemType.UnauthorisedAction);
                else
                    return; // TO-DO: Decide how to handle other error types
            }
        },
        redactUser: async function(member) {
            try {
                await redactUser(member._id);
                this.getTeamMembersList();
                const alertDto = {
                    targetUserId: member._id
                };
                this.sendAdminAlert({ type: "deleteRequest", dto: alertDto });
            } catch(er) {
                if (er.response.status === 403) {// User is not authorised to perform this action
                    this.confirmItemRemoval(this.eRemoveItemType.UnauthorisedAction);
                }
                else {
                    return; // TO-DO: Decide how to handle other error types
                }
            }
        },
        getRemovalFunction: function(){
            switch (this.itemToRemoveType){
                case this.eRemoveItemType.AdminAccess:
                    this.setAdminStatus(this.itemToRemove, true);
                    break;
                case this.eRemoveItemType.ActiveUser:
                    this.changeUserStatus(this.itemToRemove, true);
                    break;
                case this.eRemoveItemType.User:
                    this.redactUser(this.itemToRemove);
                    break;
                default:
                    return;
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
